import React from "react";

const duprRating = ({r, digits}) => <span>{(r && r > 0) ? r.toFixed(digits || 3) : <span className="text-slate-300">NR</span>}</span>

export const plDuprRating = (pl, digits) => {
  return pl && duprRating({r: pl.wpr, digits})
}

export default duprRating;